import React from 'react'

const UnderMaintenance = () => {
  return (
    <div
        className={`d-flex  justify-content-center align-items-center`}
        style={{ height: "100vh", width: "100%" }}
      >
        <div className="d-flex flex-column align-items-center justify-content-center gap-2">
          <h1 className="use-telegram-title mb-0" style={{textAlign: "center"}}>The app is currently under maintenance</h1>
        </div>
      </div>
  )
}

export default UnderMaintenance